import { driver } from '@leagueplatform/masonry';
import {
  MasonryEngineNodeRenderer,
  MasonryEngineNode,
} from '@leagueplatform/masonry-engine';
import {
  MASONRY_NAMESPACE_CHAT_HISTORY,
  NODE_TYPE_CHAT_HISTORY_CONTAINER,
  NODE_TYPE_CHAT_HISTORY_MESSAGE,
} from './constants/masonry.constants';
import {
  ChatHistoryPageLayoutRenderer,
  NODE_TYPE_CHAT_HISTORY_PAGE_LAYOUT,
} from './masonry/renderers/chat-history-page-layout/chat-history-page-layout-renderer.component';
import {
  PaginatedChatSessionListRenderer,
  NODE_TYPE_PAGINATED_CHAT_SESSION_LIST,
} from './masonry/renderers/paginated-chat-session-list/paginated-chat-session-list-renderer.component';
import {
  ChatSessionItemRenderer,
  NODE_TYPE_CHAT_SESSION_ITEM,
} from './masonry/renderers/chat-session-item/chat-session-item-renderer.component';
import {
  ChatHistoryHeroBannerRenderer,
  NODE_TYPE_CHAT_HISTORY_HERO_BANNER,
} from './masonry/renderers/hero-banner/hero-banner-renderer.component';
import {
  ChatHistoryEmptyStateRenderer,
  NODE_TYPE_CHAT_HISTORY_EMPTY_STATE,
} from './masonry/renderers/empty-state/empty-state-renderer.component';
import {
  ChatHistoryErrorStateRenderer,
  NODE_TYPE_CHAT_HISTORY_ERROR_STATE,
} from './masonry/renderers/error-state/error-state-renderer.component';
import { ChatHistoryContainerRenderer } from './masonry/renderers/chat-history-container/chat-history-container-renderer.component';
import { ChatHistoryMessageRenderer } from './masonry/renderers/chat-history-message/chat-history-message-renderer.component';
import { chatSelectActionHandler } from './masonry/actions/chat-select.action';

let masonryRegistryInitialized = false;

const registerChatHistoryRenderer = (
  nodeType: string,
  renderer: MasonryEngineNodeRenderer<MasonryEngineNode<string, any>>,
) => {
  driver.nodeRendererRegistry.registerRenderer(
    nodeType,
    MASONRY_NAMESPACE_CHAT_HISTORY,
    renderer,
  );
};

export const initMasonryRegistry = () => {
  if (masonryRegistryInitialized) return;
  masonryRegistryInitialized = true;

  registerChatHistoryRenderer(
    NODE_TYPE_CHAT_HISTORY_PAGE_LAYOUT,
    ChatHistoryPageLayoutRenderer,
  );
  registerChatHistoryRenderer(
    NODE_TYPE_PAGINATED_CHAT_SESSION_LIST,
    PaginatedChatSessionListRenderer,
  );
  registerChatHistoryRenderer(
    NODE_TYPE_CHAT_SESSION_ITEM,
    ChatSessionItemRenderer,
  );
  registerChatHistoryRenderer(
    NODE_TYPE_CHAT_HISTORY_HERO_BANNER,
    ChatHistoryHeroBannerRenderer,
  );
  registerChatHistoryRenderer(
    NODE_TYPE_CHAT_HISTORY_EMPTY_STATE,
    ChatHistoryEmptyStateRenderer,
  );
  registerChatHistoryRenderer(
    NODE_TYPE_CHAT_HISTORY_ERROR_STATE,
    ChatHistoryErrorStateRenderer,
  );
  registerChatHistoryRenderer(
    NODE_TYPE_CHAT_HISTORY_CONTAINER,
    ChatHistoryContainerRenderer,
  );
  // TODO: Remove once node spec is updated from 'chatHeader' to 'chatHistoryContainer'
  registerChatHistoryRenderer('chatHeader', ChatHistoryContainerRenderer);
  registerChatHistoryRenderer(
    NODE_TYPE_CHAT_HISTORY_MESSAGE,
    ChatHistoryMessageRenderer,
  );
  driver.actionController.registerHandler(
    'chatSelect',
    MASONRY_NAMESPACE_CHAT_HISTORY,
    chatSelectActionHandler,
  );
};
